
// 批量设置公开画面
Vue.component("public_frame_modal", {
  props: {},
  data() {
      return {
          visible: false,
          list: [],
          courseId: ''
      };
  },
  methods: {
      open(courseId) {
          this.visible = true
          this.courseId = courseId
          API.reqVideoReviewFrame({courseId}).then(res => {
              if (res.status == 200) {
                  this.list = res.data.map(el => {
                      return {
                          ...el,
                          ifPublic: el.ifPublic == 1 ? true : false
                      }
                  })
              }
          })
      },
      confirm() {
          console.log(this.list)
          const that = this
          let data = this.list.map(el => {
              return {
                  ...el,
                  ifPublic: el.ifPublic ? 1 : 0
              }
          })
          API.reqSetFramePublicBatch({courseId: this.courseId, data}).then(async(res) => {
              if (res.status == 200) {
                //全部未公开则设置为私有
                if(!that.list.filter(el=>el.ifPublic == 1).length){
                    await that.$confirm(that.$t('您选择了所有画面均不公开。将为您把改为“仅自己可见”状态。是否确认操作？', {name: that.$t('在线课堂')}), that.$t('提示'), {
                        confirmButtonText: that.$t('确定'),
                        cancelButtonText: that.$t('取消'),
                        type: 'warning',
                      }).then(async()=>{
                        await API.reqCourseBackAuthority({courseIds: [this.courseId], authority: 'private'})
                      })
                }
                this.$message.success(this.$t('设置成功'))
                this.$emit('confirm')
                this.visible = false
              }
          })
      }
  },
  template: `
      <el-dialog :visible.sync="visible" class="public_frame_modal" :title="$t('批量设置公开画面')">
          <div class="label">{{$t('批量设置公开画面')}}</div>
          <div class="frame_list">
              <div class="frame_item" v-for="(courseVideo,i) in list" :key="i">
                  <el-checkbox v-model="courseVideo.ifPublic">
                      <span>{{courseVideo.frame}}</span>
                  </el-checkbox>
              </div>
          </div>
          <div class="footer">
              <div class="tips">* {{$t('批量操作将会覆盖之前的操作结果')}}</div>
              <el-button type="primary" @click="confirm">{{$t('确认')}}</el-button>
          </div>
      </el-dialog>
  `,
});